import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {Helmet} from "react-helmet";

import './Gift.css';

class GiftThankYou extends Component {
	constructor(props) {
		super(props);

		this.state = {
			name: "your recipient"
		}
	}

	componentWillMount() {
		const recipientName = localStorage.getItem("recipient_name");
		this.unlisten = this.props.history.listen((location, action) => {
        	if (recipientName) localStorage.removeItem("recipient_name");
        });
	}

	componentDidMount() {
		const name = localStorage.getItem("recipient_name") ? localStorage.getItem("recipient_name") : "your recipient";
		this.setState({ name: name });	
	}

	componentWillUnmount() {
        this.unlisten();
    }


	render() {
		return (
			<div className="gift gift-thank-you">
				<Helmet>
                    <title>Give a Gift, Share the Love - HelloAva</title>
                    <meta name="description" content="Want to send beautifully wrapped skin care products to loved ones and friends tailored to their skin needs? Let us do the work." />
                </Helmet>
				<div className="gift-body">
					<div className="gift-section section-one thank-you">
						<img alt="Thank You!" src="/images/gift/thank-you.jpg" />
					</div>

					<div className="gift-section section-two thank-you">
						<div className="section-two-image">
							<img alt="Thank You!" src="/images/gate/thank-you.png" />
						</div>
						<div className="section-two-header">
							<p>Your gift card might take up to 24-48 hours to get to { this.state.name }'s inbox.</p>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default withRouter(GiftThankYou);



// WEBPACK FOOTER //
// ./src/views/gift/GiftThankYou.js